import { Component, OnInit } from '@angular/core';
import { Config } from 'datatables.net-dt';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-configurazione-colori',
	templateUrl: './configurazione-colori.component.html',
})
export class ConfigurazioneColoriComponent implements OnInit {
	constructor(private api: ApiService) {}

	dtTrigger: Subject<any> = new Subject<any>();
	dtSettings: Config = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: true },
			{ searchable: true, targets: 1, orderable: true },
			{ searchable: false, targets: 2, orderable: true },
			{ searchable: false, targets: 3, orderable: true },
			{ searchable: false, targets: 4, orderable: false },
		],
	};

	colori = [];

	ngOnInit() {
		this.api.getColori().subscribe((colori) => {
			this.colori = colori;
			this.dtTrigger.next();
			console.log(colori);
		});
	}

	save(colore) {
		this.api.associaColore({ id: colore.id, codiceHtml: colore.codiceHtml, ordine: colore.ordine }).subscribe(() => {
			colore.feEdit = false;
		});
	}
}
